export const ListboxDT = {
	listbox: {
		css: ({ dt }) => `
              .p-listbox-clear {
                border: none;
              }
        `,
	},
};
